import { Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { SearchService } from 'src/app/shared/services/search.service';
import { FormControl } from '@angular/forms';
import { DataService } from '../../services/data.service';
import { environment } from 'src/environments/environment';
import { Observable, debounceTime, switchMap } from 'rxjs';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { UserAgentService } from 'src/app/shared/services/user-agent.service';

@Component({
  selector: 'app-search-block',
  templateUrl: './search-block.component.html',
  styleUrls: ['./search-block.component.scss', './search-block.component.en.scss'],
})
export class SearchBlockComponent {
  isMobile: boolean = false;
  constructor(
    private searchService: SearchService,
    private dataService: DataService,
    private userAgentService: UserAgentService,
    private renderer: Renderer2
  ) {
    this.isMobile = this.userAgentService.isMobileDevice();
  }
  @ViewChild(MatAutocomplete) matAutocomplete!: MatAutocomplete;
  @Input() portalGeneralSettingsData: any;
  @Input() modalFullHeight: boolean = true;
  groupOptions: any[] | null = [];
  isOpen: boolean = false;
  searchQuery: string = '';
  searchInputControl = new FormControl<string | any>('');
  apiEndpointUrl = '/umbraco/api/SearchApi/SearchForPortalAutoComplete';
  showOpenMobileSearch: boolean = false;
  debounceTimevalue: number = 500;
  searchData: any = {
    headerSearchTitle: '',
    headerSearchPlaceholder: '',
    noResultsText: '',
    submitRedirectUrl: '',
    redirectingText: '',
  };
  filteredOptions!: Observable<any[]>;
  isLoading: boolean = false;
  @ViewChild('searchInput') searchInput!: ElementRef;

  ngOnInit() {
    this.searchData = {
      headerSearchTitle: this.portalGeneralSettingsData.headerSearchTitle,
      headerSearchPlaceholder: this.portalGeneralSettingsData.headerSearchPlaceholder,
      noResultsText: this.portalGeneralSettingsData.noResultsText,
      submitRedirectUrl: this.portalGeneralSettingsData.submitRedirectUrl,
      redirectingText: this.portalGeneralSettingsData.redirectingText,
    };

    this.filteredOptions = this.searchInputControl.valueChanges.pipe(
      debounceTime(this.debounceTimevalue),
      switchMap((value) => {
        if (!value) return [];
        const request = {
          cultureCode: this.dataService.getCultureCode(),
          term: value,
        };
        return this.dataService.getDataByToken(
          environment.apiUrl + this.apiEndpointUrl,
          request
        );
      })
    );

    this.filteredOptions.subscribe({
      next: (data) => {
        if (data && data.length > 0) {
          this.groupOptions = Object.values(data.reduce((acc, {groupName, title, absoluteUrl}) => {
            if (!acc[groupName]) {
                acc[groupName] = { groupName: groupName, options: [] };
            }
            acc[groupName].options.push({ key: title, value: absoluteUrl });
            return acc;
          }, {}));
        } else {
          this.groupOptions = null;
        }
      },
      error: (e) => console.error(e),
    });

    this.searchService.isOpen$.subscribe((isOpen) => {
      if (!isOpen) this.clearInput();
      this.isOpen = isOpen;
      if (this.isOpen) {
        setTimeout(() => {
          this.renderer.selectRootElement(this.searchInput.nativeElement).focus();
        }, 10);
      }
    });
  }

  // onArrowDown() {
  //   const activeOption = this.matAutocomplete.options.find(
  //     (option) => option.active
  //   );
  //   if (activeOption) {
  //     this.searchInputControl.setValue(activeOption.value.key);
  //   }
  // }

  // onArrowUp() {
  //   const activeOption = this.matAutocomplete.options.find(
  //     (option) => option.active
  //   );
  //   if (activeOption) {
  //     this.searchInputControl.setValue(activeOption.value.key);
  //   }
  // }

  closeSearch() {
    this.searchService.setOpen(false);
  }

  onSearchInputSubmit(value: string | undefined | object) {
    // if (this.groupOptions == null || this.groupOptions.length === 0) {
    //   this.isLoading = true;
    //   window.open(
    //     this.searchData.submitRedirectUrl + '?q=' + this.searchQuery,
    //     '_self'
    //   );
    // }
    this.isLoading = true;
      window.open(
        this.searchData.submitRedirectUrl + '?q=' + this.searchQuery,
        '_self'
      );
  }

  onSearchInputChange(event: any) {
    this.groupOptions = [];
    this.searchQuery = event.target.value;
    this.searchInputControl.setValue(this.searchQuery);
  }

  onAutocompleteSelect(item: any) {
    if (item.value) {
      this.isLoading = true;
      window.open(item.value, '_self');
    }
  }

  openSearchMobilePopup() {
    this.showOpenMobileSearch = true;
  }

  closeSearchMobilePopup() {
    this.showOpenMobileSearch = false;
    this.closeSearch();
  }

  clearInput() {
    this.groupOptions = [];
    this.searchInputControl.reset();
    this.searchQuery = '';
  }

  getPromotedSectionAdditionalClasses() {
    return this.modalFullHeight ? 'full-height-search-section' : '';
  }
}
